import LegalContentRenderer from '../components/LegalContentRenderer';
import { privacyContent } from '../mock/legalContent';

const PrivacyPolicy = () => <LegalContentRenderer content={privacyContent} />;

export default PrivacyPolicy;
